import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import { getAppContext } from '../../util/decorators';
import { formatHeadingText } from '../../util/formatSportHeadingText';
import { compose } from 'recompose';
import EnetpulseWidget from '../EnetpulseWidget.jsx';
import PageHeading from '../PageHeading.jsx';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import sportConfig from '../../config/sports';

const ADDITIONAL_SETTINGS = {
  // Soccer - premier league
  1: '/2/47',

  // Icehockey - NHL
  5: '/16/24',
};

const mapStateToProps = state => ({
  enetpulseId: _.get(sportConfig, `${state.country}.${state.mappedSportRouteParam}.id`),
  mappedSportRouteParam: state.mappedSportRouteParam,
  sport: state.routeParams.sports,
  country: state.country,
});

const Tables = ({mappedSportRouteParam, enetpulseId, app, sport, country}) =>
  <PageWithSidebars>
    <section className="tables-page">
      <PageHeading firstPart={formatHeadingText(country, sport)} secondPart={app.t('TablesIndex.heading')} />
      <EnetpulseWidget sport={mappedSportRouteParam} widgetType="standings" params={enetpulseId + (ADDITIONAL_SETTINGS[enetpulseId] || '')} className="margin-top"/>
    </section>
  </PageWithSidebars>;

Tables.propTypes = {
  route: React.PropTypes.object.isRequired,
  enetpulseId: React.PropTypes.string,
  app: React.PropTypes.object,
};

export default compose(
  connect(mapStateToProps),
  linkTag2Initializer(),
  getAppContext
)(Tables);



// WEBPACK FOOTER //
// ./src/component/WidgetPages/Tables.jsx